export enum ContentManagementSortTypes {
  NONE,
  INCREASING,
  DECREASING
}
